import config from '@/js/config.js'
import { fetchEventSource } from '@microsoft/fetch-event-source'



function send(prompt, user_input, on_message, on_error) {

    let request_headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + config['keys'][config['now_used']['key']]
    }

    let request_data = {
        "model": "deepseek-chat",
        "messages": [
            { "role": "system", "content": prompt },
            { "role": "user", "content": user_input }
        ],
        "stream": true
    }

    fetchEventSource(
        'https://api.deepseek.com/chat/completions',
        {
            'method': 'POST',
            'headers': request_headers,
            'body': JSON.stringify(request_data),
            onmessage(event) {
                on_message(event.data)
            }, onerror(error) {
                throw error
            }
        }
    ).catch((error) => {
        on_error(error)
    })
}

export default { send }